import { useState } from "react"

import { Button, EditFieldList } from "web/components"
import { Input } from "web/components/Form/Controls"

import { useFields, useLayoutFields } from "web/hooks/data"
import { useModals, useDialogModal, Dialogs } from "web/hooks/modals"

export function ShowLayout({ layout, respond, subjectType = null }) {
  const [name, setName] = useState({ value: layout.name })

  const confirmDeleteModal = useDialogModal(Dialogs.ConfirmDelete("layout"))

  const layoutFields = useLayoutFields(layout.id)
  const allFields = useFields({
    subjectType: subjectType || layout.subject_type,
    topicId: layout.topic_id,
    includeMultipleSubjectsFields: true,
  })

  async function handleSaveLayout() {
    await layout.update({ name: name.value })
    respond()
  }

  async function handleDeleteLayout() {
    const dialogResult = await confirmDeleteModal()
    if (dialogResult && dialogResult.response) {
      await layout.destroy()
      respond()
    }
  }

  const canModify = !layout.standard && layout.name !== "Summary"

  return (
    <div className="h-full">
      <div className="modal-content-above-commands">
        <div className="grid gap-y-5">
          {canModify && <Input label="Name" value={name} onChange={setName} />}
          {!canModify && (
            <div>
              <b>{layout.name}</b>
            </div>
          )}
          <EditFieldList fields={layoutFields} allFields={allFields} />
        </div>
      </div>
      <div className="modal-commands">
        <div className="left-buttons">
          <Button onClick={handleSaveLayout}>Save</Button>
        </div>
        {canModify && (
          <div className="right-buttons">
            <Button
              variant="primary_danger"
              data-testid="delete-button"
              onClick={handleDeleteLayout}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default function useShowLayoutModal() {
  const { showModal } = useModals()

  return async function (layout, subjectType) {
    return await showModal({
      title: "View/Edit Layout",
      fullScreen: false,
      heightPixels: 800,
      widthPixels: 800,
      component: ({ respond }) => (
        <ShowLayout
          layout={layout}
          respond={respond}
          subjectType={subjectType}
        />
      ),
    })
  }
}
